/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Rejestracja from './Rejestracja';
import ServicesLayout from '../../components/ServicesLayout';

/* eslint-disable global-require*/
export default {

  path: '/rejestracja',

  async action(ctx, b, c) {
    const store = ctx.store.getState();
    
    return {
      title: "e-usługi - e-spdp.pl",
      component: <ServicesLayout><Rejestracja title="Załóż konto" registerData={Object.keys(store.runtime).indexOf('registerData') >= 0 ? store.runtime.registerData : null }/></ServicesLayout>,
      description: "e-usługi - e-spdp.pl",
    };
  },
};



// WEBPACK FOOTER //
// src/routes/rejestracja/index.js